<template>
  <div class="tab tab-personnality">
    <h4>Badges obtenus</h4>
    <div class="badges-wrapper">
      <div v-for="badge, key in badgesAcquired" :key="key" class="badge">
          <img :src="badge.img" :alt="badge.title" />
          <div class="text">
            <span class="title">{{ badge.title }}</span>
            <span class="description">{{ badge.description.organisation }}</span>
          </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.badges-wrapper {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 40px;

  .badge {
    display: flex;
    gap: 24px;

    img {
      height: 100%;
    }

    .text {
      flex: 8;
      display: flex;
      flex-direction: column;
      gap: 8px;

      .title {
        font-size: 18px;
        font-weight: 600;
      }

      .description {
        font-size: 16px;        
      }
    }
  }
}
</style>

<script setup>
import { computed } from "vue";
import badges from "@/assets/badges.json";

const props = defineProps({
  currentCandidate: {
    type: Object,
    required: true,
  },
});

const badgesAcquired = computed(() => {
  return Object.entries(props.currentCandidate.results)
    .filter(([skill, value]) => skill.includes("_badge") && value === 1)
    .map( ([skill, value]) => badges[skill.replace("_badge", "")] );
});
</script>